export default __webpack_public_path__ + "static/char-s-48-ko-affc4eb75df44699c0c3d5f268152641.png";